import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "./router";
import { planner} from './store/modules/planner/store'
import { booking} from './store/modules/booking/store'
import { rideType } from './store/modules/ridetype/store'
import { messaging } from './store/modules/messaging/store'
import { availabilityRegion } from './store/modules/availabilityregion/store'
import { document } from './store/modules/document/store'
import { repeatService } from './store/modules/repeatservice/store'
import { followOnJob } from './store/modules/followonjob/store'
import { activeJob } from './store/modules/activejob/store'
import { overwatch } from './store/modules/overwatch/store'
import { unconfirmedBooking } from './store/modules/unconfirmed-booking/store'
import { dispatch } from './store/modules/dispatch/store'

Vue.use(Vuex);

axios.defaults.withCredentials = true;

export default new Vuex.Store({
  modules: {
    planner,
    booking,
    rideType,
    messaging,
    availabilityRegion,
    document,
    repeatService,
    overwatch,
    dispatch,
    unconfirmedBooking,
    followOnJob,
    activeJob
  },
  state: {
    driverGroups: [],
    loginServerURL: process.env.VUE_APP_LOGIN_SERVER_URL,
    siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    mapKey: "",
    title: "",
    apiUrl: "",
    loggedIn: false,
    loggedout: false,
    loading: true,
    autoDispatchEnabled: null,
    stripeKey: "",
    user: {
      name: ""
    },
    authUser: {},
    center: {
      lat: 50.9097, lng: -1.4044,
    },
    use_zone_based_dispatch: false,
    listeningForAutodispatch: false,
    driverToMessage: null,
    code: "",
    photosToReviewCount: 0,
    driverExpiringDocumentsCount: 0,
    taxiUnverifiedCount: 0,
    pendingDriverApplicationCount: 0,
    flightTrackingFeatureFlag: 0,
    loadingDialog: {
      show: false,
      hideOverlay: false,
      color: 'primary',
      message: ''
    },
    snackbar: {
      message: '',
      color: 'black',
      timeout: 5000,
      show: false,
    },
    bookingMenu: {}
  },
  mutations: {
    showLoadingDialog: (state, dialog) => {
      const { color, message } = dialog

      state.loadingDialog = {
        message,
        color,
        show: true
      }
    },
    hideLoadingDialog: (state) => {
      state.loadingDialog.show = false
    },
    resetLoadingDialog: (state) => {
      state.loadingDialog = {
        show: false,
        color: 'black',
        message: ''
      }
    },
    setLoggedIn(state, payload) {
      state.loggedIn = payload;
      state.loading = false;
    },
    setLoggedout(state, payload) {
      state.loggedout = payload;
    },
    setAutodispatchEnabled(state, payload) {
      state.autoDispatchEnabled = payload;
    },
    setUnverifiedTaxiPhotoUploads(state, payload) {
      state.photosToReviewCount = payload;
    },
    setDriverExpiringDocumentsCount(state, payload) {
      state.driverExpiringDocumentsCount = payload;
    },
    setUnverifiedTaxiDocumentCount(state, payload){
      state.taxiUnverifiedCount = payload;
    },
    setPendingDriverApplicationCount(state, payload) {
      state.pendingDriverApplicationCount = payload;
    },
    setFlightTrackingFeatureFlag(state, payload) {
      state.flightTrackingFeatureFlag = payload;
    },
    showSnackbar: (state, toast) => {
      const { color, timeout, message } = toast
      state.snackbar = {
        message,
        color,
        timeout,
        show: true
      }
    },
    hideSnackbar: (state) => {
      state.toast.show = false
    },
    resetSnackbar: (state) => {
      state.toast = {
        show: false,
        color: 'black',
        message: '',
        timeout: 3000
      }
    },

  },
  getters: {
    isBookingMenuOpen (state) {
        let isOpen = false
        for (let menu in state.bookingMenu) {
          if (menu[1] == true) {
            isOpen = true
          }
        }
        return isOpen
    },
    getBookingMenuStatus (state) {
      return state.bookingMenu
    },
    isMenuOpen (state) {
      return state.bookingMenu
    },
    getDriverExpiringDocumentsCount(state) {
      return state.driverExpiringDocumentsCount;
    },
    getPendingDriverApplicationCount(state) {
      return state.pendingDriverApplicationCount;
    },
    getFlightTrackingFeatureFlag(state) {
      return state.flightTrackingFeatureFlag;
    },
    getPhotosToReviewCount(state) {
      return state.photosToReviewCount;
    },
    getTaxisToReviewCount(state) {
      return state.taxiUnverifiedCount;
    },
    getLoggedIn(state) {
      return state.loggedIn;
    },
    getAutoDispatchEnabled(state) {
      return state.autoDispatchEnabled;
    },
    loadingDialog(state) {
      return state.loadingDialog
    },
    snackbar(state) {
      return state.snackbar
    },
    getAuthUser(state) {
      return state.authUser
    }
  },
  actions: {
    async checkAuth({
      state,
      commit
    }) {

      var code = localStorage.getItem("code");
      axios.defaults.headers.common[ "X-TENANT-ID"] = code;

      axios
        .post(`${state.apiUrl}/auth/checkAuth`)
        .then(response => {
          // console.log("Logged in");
          // console.log(JSON.stringify(response));

          commit("setLoggedIn", true);

          this.state.code = response.data.code;
          this.state.authUser = response.data
          localStorage.setItem("auth_email", response.data.email)

          if (!this.state.listeningForAutodispatch) {
            this.dispatch("getAutodispatch");
            this.state.listeningForAutodispatch = true;

            this.dispatch("loadConfig", { "code": this.state.code });
          }

          var s = this;
          setTimeout(function () {
            s.dispatch("checkAuth");
          }, 1500);
        })
        .catch(error => {

          if (error.message == 'Network Error') {
            console.log("Assuming disconnect")
          } else {
            console.log(error.status)
            console.log(JSON.stringify(error));


            commit("setLoggedIn", false);

            router.push({
              name: "signin",
              // query: {
              //   redirect: route.path
              // }
            });

            var s = this;
            setTimeout(function () {
              s.dispatch("checkAuth");
            }, 1500);
          }
        });
    },
    async lookupCode({
      state,
      commit
    }, {
      code,
    }) {
      try {
        let response = await axios.get(
          `${state.loginServerURL}/getConfigurationForCode?code=${code}`, {
          withCredentials: false
        }
        );

        if (process.env.VUE_APP_ENVIRONMENT && process.env.VUE_APP_ENVIRONMENT == 'windows') {
          console.log('windows')
          // this.state.apiUrl = 'http://localhost:8080/dispatch/api/dispatch';
          this.state.apiUrl = response.data.apiBaseUrl;

        } else {
          console.log('not windows')
          this.state.apiUrl = response.data.apiBaseUrl;
        }
        localStorage.setItem("apiUrl", this.state.apiUrl);
        localStorage.setItem("code", code);

        axios.defaults.headers.common[ "X-TENANT-ID"] = code;

        console.log("API BASE URL FROM CODE = " + response.data.apiBaseUrl);


        return null;

      } catch (error) {

        if (error.response != null && error.response.status == 403) {
          return "auth_failed";
        } else if (error.response.status == 404) {
          return "code_unknown"
        } else {
          return "network_error";
        }
      }
    },
    async loadConfig({
      state,
      commit
    }) {


      try {
        let response = await axios.get(
          `${state.apiUrl}/config/dispatch`, {
          withCredentials: true
        }
        );

        this.state.title = response.data.title;
        this.state.stripeKey = response.data.stripePublishableKey;
        this.state.mapKey = response.data.googleMapsKey;
        this.state.center = { lat: response.data.mapCenter.lat, lng: response.data.mapCenter.lon };

        // console.log("API BASE URL FROM CODE = " + response.data.apiBaseUrl);
        // console.log("CENTER " + JSON.stringify(this.state.center));

        return null;

      } catch (error) {

        if (error.response != null && error.response.status == 403) {
          return "auth_failed";
        } else if (error.response.status == 404) {
          return "code_unknown"
        } else {
          return "network_error";
        }
      }
    },
    async login({
      state,
      commit
    }, {
      email,
      password,
      captchaToken,
      redirect
    }) {

      try {
        let response = await axios.post(
          `${state.apiUrl}/auth/login?email=${email}&password=${password}&captchaToken=${captchaToken}&siteKey=${state.siteKey}`, {
          params: {}
        }, {
          withCredentials: true
        }
        );

        commit("setLoggedIn", true);

        this.dispatch('loadConfig');


        if (this.state.listeningForAutodispatch == false) {
          this.dispatch("getAutodispatch");
          this.state.listeningForAutodispatch = true;
        }

        //
        // if (redirect != null) {
        //   return router.push(redirect);
        // } else {
        //   return router.push("/");
        // }
      } catch (error) {

        // console.log("Network error " + JSON.stringify(error));
        commit("setLoggedIn", false);

        if (error.response != null && error.response.status == 403) {
          return "auth_failed";
        } else {
          return "network_error";
        }
      }
    },
    async logout({
      state,
      commit
    }, {
      route
    }) {
      axios
        .post(`${state.apiUrl}/auth/logout`)
        .then(response => {
          commit("setLoggedIn", false);
          localStorage.removeItem('auth_email')
          router.push("/signin");
        })
        .catch(error => {
          commit("setLoggedIn", false);
          router.push("/signin");
        });
    },
    async getAutodispatch({
      state,
      commit
    }) {

      axios
        .get(`${state.apiUrl}/overwatch/isAutoDispatchEnabled`)
        .then(response => {
          var s = this;

          setTimeout(function () {
            s.dispatch("getAutodispatch");
          }, 1500);

          commit("setAutodispatchEnabled", response.data.auto_dispatch_enabled);
          commit("setUnverifiedTaxiPhotoUploads", response.data.unverified_taxi_photo_uploads);
          commit("setDriverExpiringDocumentsCount", response.data.expiring_documents);
          commit("setPendingDriverApplicationCount", response.data.pending_driver_applications_count);
          commit("setUnverifiedTaxiDocumentCount", response.data.unverified_taxi_count);
          commit("setFlightTrackingFeatureFlag", response.data.flight_tracking_enabled);
        })
        .catch(error => {

          // console.lNetwork errorog(" " + error);
          // console.log("Network error " + JSON.stringify(error));

          if (error.response != null && error.response.status != null && error.response.status == 403) {
            console.log("Error " + JSON.stringify(error.response));

            this.state.listeningForAutodispatch = false;
            commit("setLoggedIn", false);
            router.push("/signin");

          } else {
            var s = this;

            setTimeout(function () {
              s.dispatch("getAutodispatch");
            }, 1500);
          }
        });
    },
    async toggleAutodispatch({
      state,
      commit
    }, {
      value
    }) {

      console.log("Toggling auto dispatch");

      axios
        .post(`${state.apiUrl}/overwatch/setAutoDispatch?enabled=${value}`)
        .then(response => {
          commit("setAutodispatchEnabled", value);
        })
        .catch(error => {
          alert("Failed to change auto dispatch");
        });
    },
  }
});